module.exports = __webpack_public_path__ + "static/media/7.b72c1006.jpg";